/**
 * client/ui/strings.ts — the English BO2 strings the HUD and menus use, keyed by their
 * localisation key. Text copied from game/public/assets/ui/strings-en.json (merged
 * en_code_post_gfx_mp -> en_ui_mp -> en_patch_mp, patch wins [hud.md "Strings"]); strings.test.ts
 * checks every entry against that file so a typo cannot creep in. Keys marked OURS have no
 * BO2 string (remake-only UI such as room codes) and are not checked.
 *
 * OWNER: HUD-UI-AUDIO agent.
 */
export const STR = {
  // ---- HUD / wager --------------------------------------------------------------------------
  MP_PLUS: '+',
  MP_BANKRUPTED: 'Bankrupted!',
  MP_HUMILIATED: 'Humiliated',
  MENU_WINNING_CAPS: 'WINNING',
  MENU_LOSING_CAPS: 'LOSING',
  MENU_TIED_CAPS: 'TIED',
  MEDAL_KILL_WITH_AXE_SAS: 'Bankrupted',
  MEDAL_KILL_LEADER_WITH_AXE_SAS: 'Regicide',
  MEDAL_KILL_WITH_CROSSBOW_AND_BALLISTIC_SAS: 'Switch Hitter',
  MEDAL_HEADSHOT: 'Headshot',
  MEDAL_FIRST_KILL: 'First Blood',
  MEDAL_BOUNCE_HATCHET_KILL: 'Bankshot',
  // (integration, CONTRACT-REQUESTS #G4) general score-event medals; text from strings-en.json
  MEDAL_ASSISTED_SUICIDE: 'Assisted Suicide',
  MEDAL_REVENGE_KILL: 'Revenge',
  MEDAL_BALLISTIC_KNIFE_KILL: 'Skewered',
  MEDAL_LONGSHOT_KILL: 'Long Shot',
  MEDAL_BACKSTABBER_KILL: 'Back Stabber',
  MEDAL_KILL_ENEMY_WHEN_INJURED: 'Survivor',
  MEDAL_KILL_ENEMY_AFTER_DEATH: 'Afterlife',
  MEDAL_COMEBACK_FROM_DEATHSTREAK: 'Comeback',
  MEDAL_MULTIKILL_2: 'Double Kill',
  MEDAL_MULTIKILL_3: 'Triple Kill',
  MEDAL_MULTIKILL_4: 'Fury Kill',
  MEDAL_MULTIKILL_5: 'Frenzy Kill',
  MEDAL_MULTIKILL_6: 'Super Kill',
  MEDAL_MULTIKILL_7: 'Mega Kill',
  MEDAL_MULTIKILL_8: 'Ultra Kill',
  MEDAL_MULTIKILL_MORE_THAN_8: 'Kill Chain',
  MEDAL_UNINTERRUPTED_OBIT_FEED_KILLS: 'Quad Feed',
  MP_WAGER_IN_THE_MONEY_CAPS: 'IN THE MONEY',
  MP_WAGER_LOSS_CAPS: 'OUT OF THE MONEY',
  MP_TIME_LIMIT_REACHED: 'Time limit reached',
  MP_GAME_OVER_CAPS: 'GAME OVER',
  MPUI_WINNINGS_CAPS: 'WINNINGS',
  OBJECTIVES_SAS_SCORE: 'Eliminate other players. Bankrupt opponents using the Tomahawk.',
  OBJECTIVES_SAS_HINT: 'ELIMINATE OTHER PLAYERS',
  MPUI_SAS_CAPS: 'STICKS AND STONES',
  MPUI_SAS: 'Sticks and Stones',
  MPUI_HIJACKED: 'Hijacked',
  MPUI_HIJACKED_CAPS: 'HIJACKED',
  MPUI_HIJACKED_LOC: 'INTERNATIONAL WATERS',
  MPUI_DESC_MAP_HIJACKED: 'Luxurious super yacht. Frantic, yet controlled close quarters engagements.',
  MENU_SAS_DESC: 'You get a Crossbow, a Ballistic Knife, and a Combat Axe.  Kill players to score points. Combat Axe kills will reset enemy scores to zero. Good luck.',
  WEAPON_CROSSBOW_EXPLOSIVE: 'Crossbow',
  WEAPON_KNIFE_BALLISTIC: 'Ballistic Knife',
  WEAPON_HATCHET: 'Combat Axe',
  CGAME_CONNECTIONINTERUPTED: 'Connection Interrupted',
  MP_KILLCAM_CAPS: 'KILLCAM',
  CGAME_KILLED: 'Killed',
  CGAME_KILLEDBY: 'Killed By',
  MP_FINAL_KILLCAM_CAPS: 'FINAL KILLCAM',
  PLATFORM_PRESS_TO_SKIP: 'Press ^3[{+activate}]^7 to skip',
  // scoreboard column headers (sas.gsc setscoreboardcolumns; pointstowin header ESTIMATE = MPUI_SCORE)
  MPUI_SCORE: 'Score',
  MPUI_KILLS: 'Kills',
  MPUI_DEATHS: 'Deaths',
  MPUI_TOMAHAWKS: 'Axes',
  MPUI_HUMILIATED: 'Setbacks',
  MENU_PING_CAPS: 'PING',
  MPUI_ORDINAL_CAPS_1: '1ST',
  MPUI_ORDINAL_CAPS_2: '2ND',
  MPUI_ORDINAL_CAPS_3: '3RD',
  MPUI_ORDINAL_CAPS_4: '4TH',
  // loading-screen tips for sas [hud.md "Loading screen"]
  MPTIP_WAGER_GOLD_DOT: 'The player who is in first place appears as a gold dot on your minimap.',
  MPTIP_WAGER_STICKS_TOMAHAWK: 'Kill a player with the Combat Axe in Sticks and Stones to reset their score back to zero.',
  MPTIP_WAGER_STICKS_POINTS: 'In Sticks and Stones, melee kills and Combat Axe kills are worth less points than other weapons.',
  MPTIP_WAGER_STICKS_SPYPLANE: 'In Sticks and Stones, all enemy players are revealed on your mini-map, but with a delay.',
  MPTIP_ADS_TIP: 'Firing while aiming down your sight increases your accuracy.',
  // ---- menus --------------------------------------------------------------------------------
  MENU_MULTIPLAYER_CAPS: 'MULTIPLAYER',
  MENU_PARTYGAMES_CAPS: 'PARTY GAMES',
  MPUI_BASICTRAINING_CAPS: 'COMBAT TRAINING',
  MENU_BASICTRAINING_DIFFICULTY_CAPS: 'BOT DIFFICULTY',
  MPUI_START_MATCH_CAPS: 'START MATCH',
  MENU_JOIN_GAME_CAPS: 'JOIN GAME',
  MENU_LOBBY_CAPS: 'LOBBY',
  MENU_PLAYERS_CAPS: 'PLAYERS',
  MENU_HOST_CAPS: 'HOST',
  MENU_RESUMEGAME_CAPS: 'RESUME GAME',
  MENU_OPTIONS_CAPS: 'OPTIONS',
  MENU_LEAVE_GAME_CAPS: 'LEAVE GAME',
  MENU_END_GAME_CAPS: 'END GAME',
  MENU_BACK_CAPS: 'BACK',
  MENU_CONTROLS_CAPS: 'CONTROLS',
  MENU_SETTINGS_CAPS: 'SETTINGS',
  MENU_GRAPHICS_CAPS: 'GRAPHICS',
  MENU_AUDIO_SETTINGS_CAPS: 'AUDIO SETTINGS',
  MENU_LOOK_SENSITIVITY_CAPS: 'LOOK SENSITIVITY',
  MENU_LOOK_INVERSION_CAPS: 'LOOK INVERSION',
  MENU_BUTTON_LAYOUT_CAPS: 'BUTTON LAYOUT',
  MENU_STICK_LAYOUT_CAPS: 'STICK LAYOUT',
  MENU_TARGET_ASSIST_CAPS: 'TARGET ASSIST',
  MENU_AIM_DOWN_THE_SIGHT_AUTOAIM: 'Autoaim when Aiming Down the Sight',
  MENU_CONTROLLER_VIBRATION_CAPS: 'CONTROLLER VIBRATION',
  MENU_MOUSE_SENSITIVITY_CAPS: 'MOUSE SENSITIVITY',
  MENU_INVERT_MOUSE_CAPS: 'INVERT MOUSE',
  PLATFORM_FIELD_OF_VIEW_CAPS: 'FIELD OF VIEW',
  MENU_MASTER_VOLUME_CAPS: 'MASTER VOLUME',
  MENU_SFX_VOLUME_CAPS: 'SFX VOLUME',
  MENU_MUSIC_VOLUME_CAPS: 'MUSIC VOLUME',
  MENU_CROUCH_CAPS: 'CROUCH',
  MENU_PRONE_CAPS: 'PRONE',
  MENU_DEFAULT_CAPS: 'DEFAULT',
  MENU_TACTICAL_CAPS: 'TACTICAL',
  MENU_LEFTY_CAPS: 'LEFTY',
  MENU_CHARLIE_CAPS: 'CHARLIE',
  MENU_SOUTHPAW_CAPS: 'SOUTHPAW',
  MENU_LEGACY_CAPS: 'LEGACY',
  MENU_LEGACY_SOUTHPAW_CAPS: 'LEGACY SOUTHPAW',
  MENU_FLIPPED_CAPS: 'FLIPPED',
  MENU_ENABLED_CAPS: 'ENABLED',
  MENU_DISABLED_CAPS: 'DISABLED',
  MENU_ON_CAPS: 'ON',
  MENU_OFF_CAPS: 'OFF',
  MENU_YES_CAPS: 'YES',
  MENU_NO_CAPS: 'NO',
  MENU_RECRUIT_CAPS: 'RECRUIT',
  MENU_REGULAR_CAPS: 'REGULAR',
  MENU_HARDENED_CAPS: 'HARDENED',
  MENU_VETERAN_CAPS: 'VETERAN',
  MPUI_RULES_TIME_LIMIT_CAPS: 'TIME LIMIT',
  EXE_LOADING: 'Loading',
  EXE_AWAITINGHOST: 'Waiting for other players',
} as const;

/** Remake-only labels (no BO2 string exists). */
export const OURS = {
  PLAY_SOLO: 'Play solo (bots)',
  CREATE_ROOM: 'Create online room',
  JOIN_ROOM: 'Join room',
  ROOM_CODE: 'ROOM CODE',
  SHARE_LINK: 'SHARE LINK',
  COPY_LINK: 'COPY LINK',
  BOTS: 'BOTS',
  NAME: 'NAME',
  TRIGGERS_FLIPPED: 'FLIPPED TRIGGERS',
  NOMAD: 'NOMAD',
  TOGGLE_CROUCH: 'TOGGLE CROUCH',
  TOGGLE_ADS: 'TOGGLE ADS',
  ADS_MOUSE_SCALE: 'ADS SENSITIVITY RATIO',
  RENDER_SCALE: 'RENDER SCALE',
  SHADOWS: 'SHADOWS',
  DEBUG_OVERLAY: 'NET DEBUG OVERLAY',
  TIME_NUDGE: 'TIME NUDGE',
  VOICE_VOLUME: 'ANNOUNCER VOLUME',
  ALT_STICK_CURVE: 'ALT STICK CURVE',
  KEYBINDS: 'KEYBOARD / MOUSE',
  CONNECTING: 'CONNECTING',
  WAITING_LEADER: 'Waiting for the host to start the match',
} as const;

export type StrKey = keyof typeof STR;

/** Replace &&1, &&2... parameters (BO2 localisation format). */
export function fmt(s: string, ...args: (string | number)[]): string {
  return s.replace(/&&(\d)/g, (_m, i: string) => String(args[Number(i) - 1] ?? ''));
}

/** "1ST".."4TH", then the generic English ordinal for later places. */
export function ordinalCaps(place: number): string {
  const k = `MPUI_ORDINAL_CAPS_${place}` as StrKey;
  if (k in STR) return STR[k];
  const m100 = place % 100, m10 = place % 10;
  const suf = m100 >= 11 && m100 <= 13 ? 'TH' : m10 === 1 ? 'ST' : m10 === 2 ? 'ND' : m10 === 3 ? 'RD' : 'TH';
  return `${place}${suf}`;
}
